/**
 * HTTP layer for vendors. The suppliers parts are purchased from.
 *
 * Contains:
 * - fetchVendors / fetchVendor: reads
 * - postVendor / patchVendor / deleteVendor: writes
 */
import apiClient from '@sophocles/http-common';

const VENDOR_ENDPOINT = '/warehouse/vendors';

export const fetchVendors = queryParams =>
  apiClient.get(`${VENDOR_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchVendor = vendorId => apiClient.get(`${VENDOR_ENDPOINT}/${vendorId}/`).then(res => res.data);

export const postVendor = data => apiClient.post(`${VENDOR_ENDPOINT}/`, data).then(res => res.data);

export const patchVendor = (vendorId, data) =>
  apiClient.patch(`${VENDOR_ENDPOINT}/${vendorId}/`, data).then(res => res.data);

export const deleteVendor = vendorId => apiClient.delete(`${VENDOR_ENDPOINT}/${vendorId}/`);
